import { render, staticRenderFns } from "./DepartmentsTable.vue?vue&type=template&id=739f64e4&"
import script from "./DepartmentsTable.vue?vue&type=script&lang=js&"
export * from "./DepartmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports